import moment from 'moment-timezone'
import i18n from 'services/i18n'

export function mapGetRibbons (entity, shouldShowExpiredRibbon = false) {
    if (!entity) {
        return null
    }
    let expireDate = entity.expirationDate
    let today = moment().tz(this.getTimeZone()).startOf('day')
    let expiredDiff = expireDate !== null ? today.diff(expireDate, 'days') : null
    let expiredStatuses = ['draft', 'expired']

    if (shouldShowExpiredRibbon && (
        (expiredDiff > 0 && expiredDiff !== null) ||
        expiredStatuses.includes(entity.status) || expiredStatuses.includes(entity.statusValue) || entity.learningPath?.isExpired
    )) {
        return {
            name: i18n.t('Ribbon.unavailable'),
            color: 'unavailable',
            timeBased: false
        }
    }
    if (entity.flags && entity.flags.length > 0) {
        switch (entity.flags[0]) {
        case 'highlight':
            return {
                name: i18n.t('Ribbon.favourite'),
                color: 'favourite',
                timeBased: false
            }
        case 'trending':
            return {
                name: i18n.t('Ribbon.topical'),
                color: 'topical',
                timeBased: false
            }
        case 'customer':
            return {
                name: i18n.t('Ribbon.customer'),
                color: 'customer',
                timeBased: false
            }
        }
    }

    return null
}

export function mapGetTimeBasedRibbons (entity) {
    if (!entity) {
        return null
    }

    let publishDate = entity.publishDate
    let expireDate = entity.expirationDate
    let today = moment().tz(this.getTimeZone()).startOf('day')
    let publishedDiff = today.diff(publishDate, 'days')
    let expiredDiff = expireDate !== null ? today.diff(expireDate, 'days') : null

    if (publishDate !== null && publishedDiff < 0) {
        return {
            name: i18n.t('Ribbon.coming'),
            color: 'upcoming',
            timeBased: true
        }
    }
    if (expiredDiff !== null && expiredDiff > -30 && expiredDiff <= 0) {
        return {
            name: i18n.t('Ribbon.expiring'),
            color: 'expiring',
            timeBased: true
        }
    }
    if (publishDate !== null && publishedDiff >= 0 && publishedDiff <= 14) {
        return {
            name: i18n.t('Ribbon.new'),
            color: 'new',
            timeBased: true
        }
    }

    return null
}

export function mapCourseToTitle (course) {
    if (!course) {
        return null
    }

    return course.title
}
